/**
 * When to show the bestsellers bacon
 * @param {object} article
 */
export const shouldShowProductBacon = (article) => Boolean(article.ecommerceEnabled)
  && !article?.presentation?.hideProductRecommendations;

/**
 * When to show the today reader favorites product bacon
 * @param {object} article
 * @param {object} flags
 */
export const shouldShowTodayProductBacon = (article, flags) => shouldShowProductBacon(article)
  && Object.keys(flags?.['reader-favorites-and-customization'] || {}).length;

/**
 * @param {object} flags
 * @param {object} curatedList
 * @param {string} metaDataTitle
 */
export const getRecircBaconTitle = (flags, curatedList, metaDataTitle) => {
  const {
    'bestseller-bacon-customization': { title: bestsellerTitle } = {},
    'reader-favorites-and-customization': { title: readerFavoritesTitle } = {},
  } = flags;

  const isReadersFavoritesBacon = metaDataTitle === 'Shop TODAY Reader Favorites';

  return (
    (isReadersFavoritesBacon && readerFavoritesTitle)
    || (!curatedList && !isReadersFavoritesBacon && bestsellerTitle)
    || metaDataTitle
    || ''
  );
};

/**
 * When to show the boxes bestsellers bacon
 * @param {string} vertical
 * @param {object} article
 * @param {object} boxesBestsellersCuratedList
 */
export const shouldShowBoxesBestsellersBacon = (
  vertical,
  article,
  boxesBestsellersCuratedList,
) => {
  const primarySectionName = article?.taxonomy?.primarySection?.name ?? '';
  const isPrimarySectionShop = primarySectionName.toLowerCase() === 'shop';

  return vertical === 'today'
  && isPrimarySectionShop
  && Boolean(article.ecommerceEnabled)
  && Boolean(boxesBestsellersCuratedList);
};
